<template>
  <Fragment>
    <template v-if="$route.name !== 'activitiesIndex'">
      <router-view></router-view>
    </template>
    <section class="container" v-else>
      <Breadcrumb />
      <div class="card-wrap mt-20 mb-20">
        <section class="card-content">
          <div class="left">
            <div class="search-name mr-15">
              <span>活码名称：</span>
              <el-input v-model="activitiesName"> </el-input>
            </div>
            <el-button
              type="primary"
              class="ml-20"
              @click="searchActivitiesInfo"
              >查询</el-button
            >
          </div>
        </section>
      </div>
      <el-table :data="list" style="width: 100%" border>
        <el-table-column label="序号" width="50">
          <template slot-scope="scope">
            <span>{{ scope.$index + (pageNum - 1) * pageSize + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="活码名称" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.activitiesName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="描述" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.des }}</span>
          </template>
        </el-table-column>
        <el-table-column label="着陆页" :fit="true">
          <template slot-scope="scope">
            <span>{{ scope.row.activitiesUrl }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button size="mini" @click="editActivitiesInfoById(scope.row)"
              >编辑</el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click="deleteActivities(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20 pagination"
        background
        layout="total,prev, pager, next, jumper"
        :total="total"
        :page-size="10"
        :current-page="pageNum"
        @prev-click="handlePrePage"
        @next-click="handleNextPage"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </section>
  </Fragment>
</template>

<script>
import { Fragment } from "vue-fragment";

import Breadcrumb from "@/components/Breadcrumb";
export default {
  name: "role",
  components: {
    Breadcrumb,
    Fragment
  },
  data() {
    return {
      activitiesId: "",
      activitiesName: "",
      list: [],
      pageNum: 1,
      pageSize: 10,
      total: 0
    };
  },
  methods: {
    getActivitiesList() {
      let _this = this;
      let param = {
        url: "/api/activities/getActivitiesPage",
        params: {
          activitiesName: _this.activitiesName,
          pageNum: _this.pageNum,
          pageSize: _this.pageSize
        }
      };

      _this.$store.dispatch("getActivitiesList", param).then(() => {
        _this.list = _this.$store.state.activities.activitiesList.list;
        _this.total = _this.$store.state.activities.activitiesList.total;
      });
    },
    //查询
    searchActivitiesInfo() {
      let _this = this;
      _this.getActivitiesList();
    },
    //当前页
    handleCurrentChange(value) {
      let _this = this;
      _this.pageNum = value;
      _this.getActivitiesList();
    },
    //上一页
    handlePrePage() {
      let _this = this;
      _this.pageNum -= 1;
      _this.getActivitiesList();
    },
    //下一页
    handleNextPage() {
      let _this = this;
      _this.pageNum += 1;
      _this.getActivitiesList();
    },
    //编辑
    editActivitiesInfoById(row) {
      this.$router.push({
        name: "editActivitiesInfoById",
        params: { activitiesId: row.activitiesId }
      });
    },
    //删除
    deleteActivities: function(row) {
      let _this = this;
      if (confirm("确定要删除吗") === true) {
        let param = {
          url: "/api/activities/deleteActivitiesInfoById",
          params: { activitiesId: row.activitiesId }
        };

        _this.$Api
          .get(param.url, param.params)
          .then(response => {
            if (response.status === 200) {
              _this.getActivitiesList();
              _this.$message({
                message: "活码信息删除成功",
                type: "success"
              });
              this.$router.push({
                name: "activitiesIndex"
              });
            } else {
              _this.$message({
                message: response.data.msg,
                type: "error"
              });
            }
          })
          .catch(err => {});
      }
    }
  },
  created() {
    let _this = this;
    _this.getActivitiesList();
  }
};
</script>

<style lang="sass" scoped>
.card-wrap
  .card-content
    display: flex
    align-items: center
    justify-content: space-between
    .left
      display: flex
    .el-button
      font-size: 14px
    .search-name, .search-code
      font-size: 14px
      display: flex
      align-items: center
      span
        white-space: nowrap
.pagination
  text-align: center
</style>
